import { Grid } from '@material-ui/core';
import { useStyles } from '../../../../../PageResultat/ResultatMeanning/FirstView/Podium/style';
import { meaningRankColors } from '../content/meaningPresentation';

const MeaningResultPodium = ({ results }: { results: any[] }) => {
  const classes = useStyles();
  const columns = [
    { result: results[1], rank: 1, barClass: classes.second },
    { result: results[0], rank: 0, barClass: classes.first },
    { result: results[2], rank: 2, barClass: classes.third },
  ];

  return (
    <>
      <div className={`${classes.root} ${classes.withBorder}`}>
        <Grid container={true} direction="row" justifyContent="center" alignItems="flex-end">
          {columns.map(({ result, rank, barClass }) => (
            <Grid item={true} key={rank}>
              <div
                className={`${barClass} ${classes.contentPodium}`}
                style={{ background: meaningRankColors[rank] }}>
                {result?.score || 0} <span className={classes.textFLoating}>/100</span>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
      <div className={classes.root}>
        <Grid container={true} direction="row" justifyContent="center" alignItems="flex-end">
          {columns.map(({ result, rank }) => (
            <Grid item={true} key={rank}>
              <div className={classes.titleContent}>
                {rank === 0 ? <b>{result?.label || ''}</b> : result?.label || ''}
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default MeaningResultPodium;
